import { createReducer, on } from '@ngrx/store';
import { MatchingActions } from './matching.actions';
import { MatchingState, initialMatchingState } from './models/matching-state.models';
import { MatchProposal } from '@app/core/api/matching';

/** Remove a proposal by ID from all match arrays */
function removeProposal(state: MatchingState, proposalId: string): MatchingState {
  if (!state.matches) return state;
  const filter = (arr: MatchProposal[]) => arr.filter(m => m.proposal_id !== proposalId);
  const matches = {
    ...state.matches,
    shown: filter(state.matches.shown),
    active: filter(state.matches.active),
    connected: filter(state.matches.connected),
    history: filter(state.matches.history),
  };
  return { ...state, matches };
}

export const matchingReducer = createReducer(
  initialMatchingState,

  // ── Load matches ──────────────────────────────────────
  on(MatchingActions.loadMatches, (state): MatchingState => ({
    ...state,
    loading: state.matches === null,
    error: null,
  })),
  on(MatchingActions.loadMatchesSuccess, (state, { matches }): MatchingState => ({
    ...state,
    matches,
    loading: false,
    error: null,
  })),
  on(MatchingActions.loadMatchesFailure, (state, { error }): MatchingState => ({
    ...state,
    loading: false,
    error,
  })),

  // ── Respond to match (optimistic: remove card immediately) ──
  on(MatchingActions.respondToMatch, (state, { proposalId }): MatchingState => ({
    ...removeProposal(state, proposalId),
    error: null,
  })),
  on(MatchingActions.respondToMatchSuccess, (state): MatchingState => state),
  on(MatchingActions.respondToMatchFailure, (state, { error }): MatchingState => ({
    ...state,
    error,
  })),

  // ── Cancel match (optimistic: remove card immediately) ──
  on(MatchingActions.cancelMatch, (state, { proposalId }): MatchingState => ({
    ...removeProposal(state, proposalId),
    error: null,
  })),
  on(MatchingActions.cancelMatchSuccess, (state): MatchingState => state),
  on(MatchingActions.cancelMatchFailure, (state, { error }): MatchingState => ({
    ...state,
    error,
  })),

  // ── Clear error ───────────────────────────────────────
  on(MatchingActions.clearError, (state): MatchingState => ({
    ...state,
    error: null,
  })),

  // ── Clear all matching state on logout ────────────────
  on(MatchingActions.clearMatches, (): MatchingState => initialMatchingState),
);
